import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OneToMany } from 'typeorm';
import { FgStatusEnum, GlobalStatus, OperationTypeEnum, PlantsEnum, SubPlantCodesEnum } from '@gtpl/shared-models/common-models';

export class ProdInvDTO {
  @ApiProperty()
  @IsOptional()
  productionInventoryId?: number;

  @ApiProperty()
  @IsOptional()
  grnNumber?: string;

  @ApiProperty()
  @IsOptional()
  lotNumber?: string;

  @ApiProperty()
  @IsOptional()
  saleOrderId?: number;

  @ApiProperty()
  @IsOptional()
  saleOrderItemId?: number;

  @ApiProperty({
    enum: OperationTypeEnum
  })
  // @IsEnum(PlantsEnum)
  operation: OperationTypeEnum;

  @ApiProperty({
    enum: OperationTypeEnum
  })
  // @IsEnum(PlantsEnum)
  nextOperation: OperationTypeEnum;

  @ApiProperty()
  @IsNotEmpty({ message: "Quantity should not be empty" })
  physicalQuantity: number;

  @ApiProperty()
  // @IsNotEmpty({message:"Price should not be empty"})
  inputGrade: number;

  @ApiProperty()
  // @IsEnum(PlantsEnum)
  plantId: number;

  @ApiProperty()
  subPlantId: number;

  // @ApiProperty({
  //   enum: SubPlantCodesEnum
  // })
  // // @IsEnum(SubPlantCodesEnum)
  // subPlantId: SubPlantCodesEnum;

  @ApiProperty()
  // @IsNotEmpty({message:"Price should not be empty"})
  boxes: number;

  @ApiProperty({
    enum: GlobalStatus
  })
  // @IsEnum(GlobalStatus)
  weighmentReq: GlobalStatus;

  @ApiProperty({
    enum: FgStatusEnum
  })
  // @IsEnum(GlobalStatus)
  status: FgStatusEnum;


  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  createdAt: Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
  createdUser: string;

  updatedAt: Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
  updatedUser: string;

  @ApiProperty()
  versionFlag: number;
}
